/**
 * Lottery 108 (RSGV) may correct the prize counts of a drawing in any workflow
 * state; every other lottery only while the drawing is open or rejected. The id
 * is the whole rule — the old app hardcodes it the same way and the `lottery`
 * table carries no flag for it (`Drawing.scala:136`: `108 == LotteryId`).
 */
export const RSGV_LOTTERY_ID = 108;

export const isRsgvLottery = (lotteryId?: string | number | null): boolean => Number(lotteryId) === RSGV_LOTTERY_ID;
